import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PartnerSelector from './PartnerSelector';
import navRoutes from '../../constants/navRoutes';
import utils from '../../lib/utils';
import * as partnerActions from '../../actions/partnerActions';
import { withRouter } from 'react-router-dom';
import { HeaderNav, SocialRibbon } from '@forwardfinancing/component-library';

export class WrappedHeader extends Component {

  isAdmin() {
    return this.props.user && utils.isAdmin(this.props.user.role);
  }

  navItems() {
    let navItems;
    
    try {
      const userProfileNav = this._userProfileNavItem();
      if (this.isAdmin()) {
        const { search } = this.props.location || {};
        const partnerSelectorControl = {
          customClass: 'nav-partner-selector',
          customItem: <PartnerSelector params={search} />,
          key: 'li-partner-selector'
        };

        navItems = [...navRoutes.sharedNavRoutes, userProfileNav, partnerSelectorControl];
      } else {
        navItems = this.hasPartnerAccessToDualForm() ?
          [...navRoutes.sharedNavRoutes, navRoutes.dualSubmissionRoutes, userProfileNav] :
          [...navRoutes.sharedNavRoutes, navRoutes.singleSubmissionRoute, userProfileNav];
      }
    } catch(err){
      console.log(err);
    }
    return navItems;
  }

  _userProfileNavItem(){
    const { name, first_name, last_name, email } = this.props.user;
    // name (oauth2-proxy's claim) is set for every user; first/last aren't for authentik-native ones.
    const fullName = name || (first_name && last_name ? `${first_name} ${last_name}` : '');
    const userInfoCustomNavItem = (<React.Fragment>
      <span className="name">{fullName}</span>
      <span className="email">{email}</span>
    </React.Fragment>);
    const userProfileNav = {
      icon: 'icon-user-profile',
      customClass: 'nav-user-profile',
      navItems: [
        { customClass: 'user-info hidden-sm-down', customItem: userInfoCustomNavItem, key: 'li-user-info' },
        navRoutes.logoutRoute
      ]
    };
    return userProfileNav;
  }

  hasPartnerAccessToDualForm() {
    const partnerInfo = this.props.partner.fundingPartnerData;
    return partnerInfo && partnerInfo.dual_form_view;
  }

  render() {
    return (
      <div className="wrapped-header">
        <SocialRibbon />
        <HeaderNav customClass="container aligned-nav-header" logoRoute={navRoutes.logoRoute} navItems={this.navItems()} toolbarItems={this.props.toolbarItems} />
      </div>
    );
  }
}

WrappedHeader.propTypes = {
  user: PropTypes.object, // logged-in user
  partner: PropTypes.object, // partner[s] data
  toolbarItems: PropTypes.arrayOf(PropTypes.element),
  location: PropTypes.object,
  partnerActions: PropTypes.object
};

function mapStateToProps(state) {
  return {
    user: state.user,
    partner: state.partner,
    toolbarItems: state.headerNavToolbarItems
  };
}

function mapDispatchToProps(dispatch) {
  return {
    partnerActions: bindActionCreators(partnerActions, dispatch)
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(WrappedHeader));
